import { render, staticRenderFns } from "./Downline.vue?vue&type=template&id=2bcc55fb&scoped=true&"
import script from "./Downline.vue?vue&type=script&lang=ts&"
export * from "./Downline.vue?vue&type=script&lang=ts&"
import style0 from "./Downline.vue?vue&type=style&index=0&id=2bcc55fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc55fb",
  null
  
)

export default component.exports